<template>
  <div>
    <b-button
      variant="link"
      class="p-0 m-0 ml-2 text-md"
      v-b-tooltip
      :id="`tooltip-button-${_uid}`"
    >
      <b-icon-info-circle />
    </b-button>
    <b-tooltip :target="`tooltip-button-${_uid}`" triggers="focus" custom-class="list-card-tooltip">
      <slot>{{ text }}</slot>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  data() {
    return {
      text: this.$t('childPage.originalRecord')
    }
  }
}
</script>
